import React, { useEffect, useRef, useState, useContext } from "react";

import { Button, Toast, Badge } from 'primereact';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { formatFecha } from "../../../../Base/Services/FechasService";
import CardInterior from "../../../../Base/Components/Card/CardInterior";
import { toastShow } from "../../../../Base/Services/ToastService";

import { detenerTarea, getAsignacionesPorPersonal, getAsignacionesPorPersonalFilt, getAsignacionesTotales, getOrdenesTrabajoDet, iniciarTarea, terminarTarea } from "../../../../API/Mantenimiento/OrdenesTrabajo/OrdenesTrabajoRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { getPersonal } from "../../../../API/RRHH/Personal/PersonalRequests";

import { colorsStatus } from "../../../../Styles/coloresEstados";
import CrudRequisa from "../../Compras/Requisas/CrudRequisa/CrudRequisa";
import RequisaMaterialCrud from "../../Suministros/Bodegas/RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";
import RequisasDeAsignaciones from "./OrdenesTrabajoCRUD/RequisasDeAsignaciones";
import OrdenesTrabajoCRUD from "./OrdenesTrabajoCRUD/OrdenesTrabajoCRUD";
        

const AsignacionesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [asignaciones, setAsignaciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [personalAsignado, setPersonalAsignado] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialog2, setShowDialog2] = useState(false);
  const [comment, setComment] = useState(null);
  const [idAsig, setIdAsig] = useState(null);
  const [ordenesDet, setOrdenesDet] = useState([]);
  const [detener, setDetener] = useState(false);
  const [iniciar, setIniciar] = useState(false);
  const [finalizar, setFinalizar] = useState(false);

  const [abrirRequisaCompras, setAbrirRequisaCompras] = useState(false);
  const [abrirRequisaMaterial, setAbrirRequisaMaterial] = useState(false);
  const [item, setItem] = useState([]);
  const [habilitarReqCompras, setHabilitarReqCompras] = useState(true);
  const [habilitarReqMaterial, setHabilitarReqMaterial] = useState(true);
  const [ingresoToShow, setIngresoToShow] = useState(true);
  const [showRequisas, setShowRequisas] = useState(false);
  const [ordenToShow, setOrdenToShow] = useState(null);
  const [habilitar, setHabilitar] = useState(true);
  

  const [hiddenMantenimiento, setHiddenMantenimiento] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(44));

  const initialValues = {
    IdEstado: null,
    Estado: '',
    IdPersonal: null,
    Personal: ''
  };

  const { values, setValues, handleInputChange } = useForm(initialValues);

  const getInfo = async () => {
    setLoading(true);
    let asignacionesTempo

    const estadosTempo = await getEstadosCategory('OrdenesDeTrabajo')
    const exclude = estadosTempo.filter((e) =>  e.IdStatus !== 47)
    setEstados(exclude)

    const personalTempo = await getPersonal()
    setPersonalAsignado(personalTempo)

    const ordenesDetTempo = await getOrdenesTrabajoDet()
    setOrdenesDet(ordenesDetTempo)

    if(userAuth?.IdRol === 1 || hiddenMantenimiento){
      asignacionesTempo = await getAsignacionesTotales();
    }else{
      asignacionesTempo = await getAsignacionesPorPersonal(userAuth?.IdPersonalInt);
    }

    ordenarAsignacionesPorIdDet(asignacionesTempo, ordenesDetTempo, null);

    setAsignaciones(asignacionesTempo);
    setValues(initialValues)
    setLoading(false);
  };

  const ordenarAsignacionesPorIdDet = (asignaciones, ordenesDet, estadoFiltrado) => {
    const asignacionesAgrupadas = ordenesDet.map(orden => {
      const asignacionesParaOrdenDet = asignaciones
        .filter(asignacion => asignacion.IdOrdenDeTrabajoDet === orden.IdOrdenDeTrabajoDet)
        .map(asignacion => ({
          ...asignacion,
          NombreConcatenado: asignacion.NombreConcatenado
            ? asignacion.NombreConcatenado.split(',').map(nombre => nombre.trim())
            : [],
        }));
  
      if (asignacionesParaOrdenDet.length === 0) {
        return null;
      }
      return {
        ...orden,
        asignaciones: asignacionesParaOrdenDet,
      };
    }).filter(orden => orden !== null);

    return asignacionesAgrupadas
  };
  
  const asignacionesAgrupadas = ordenesDet.map(orden => {
    const asignacionesParaOrdenDet = asignaciones
      .filter(asignacion => asignacion.IdOrdenDeTrabajoDet === orden.IdOrdenDeTrabajoDet)
      .map(asignacion => ({
        ...asignacion,
        NombreConcatenado: asignacion.NombreConcatenado
          ? asignacion.NombreConcatenado.split(',').map(nombre => nombre.trim())
          : [],
      }));

    if (asignacionesParaOrdenDet.length === 0) {
      return null;
    }
    return {
      ...orden,
      asignaciones: asignacionesParaOrdenDet,
    };
  }).filter(orden => orden !== null);

  const OrdenT = (Id) => {
    setOrdenToShow(Id);
    setShowDialog2(true);
  };


  const renderizarOrdenes = (asignacionesAgrupadas) => {
    return (
      <div className="flex-wrap gap-4 mt-2">
        {asignacionesAgrupadas.map((orden, index) => (
          <Card
            key={index}
            contenido={
              <div style={{ width: "160vh" }}>
                <div className="d-flex py-1 gap-4">
                  <div
                    className="fw-bold"
                    style={{ cursor: 'pointer', background: 'none',  border: 'none',  padding: 0,  color: 'inherit', }}
                    onClick={() => {
                      OrdenT(orden.NoOrdenTrabajo)
                    }}
                  >
                    {orden.NoOrdenTrabajo}
                  </div>
                  <Badge
                    value={orden?.Priority}
                    style={colorsStatus["priority" + orden?.IdPrioridad]}
                  />
                </div>
                <div style={{ borderBottom: "1px solid #ccc" }}></div>
                <div className="mt-2">
                  <div>
                    <h6>
                      <strong>
                        {getLabel(baseLang, "fechaCreat", config.language)}:{" "}
                      </strong>
                      {formatFecha(orden.FechaCreado)}
                    </h6>
                    <h6>
                      <strong>
                        {getLabel(baseLang, "areaGeneral", config.language)}:{" "}
                      </strong>
                      {orden.Area}
                    </h6>
                    <h6>
                      <strong>
                        {getLabel(baseLang, "categoria", config.language)}:{" "}
                      </strong>
                      {orden.Type ? orden.Type : "Sin Activo"}
                    </h6>

                    <h6>
                      <strong>
                        {getLabel(baseLang, "solicita", config.language)}:{" "}
                      </strong>
                      {orden.UserNameSolicita}
                    </h6>
                  </div>
                </div>

                <div className="d-flex gap-4 flex-wrap">
                  {orden.asignaciones.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex-item col-3"
                      style={{ width: "32%" }}
                    >
                      <CardInterior
                        contenido={
                          <div>
                            <div style={{ height: "22vh" }}>
                              <div className="d-flex justify-content-between pb-1">
                                {item?.CodigoActivo ? (
                                  <div className="fw-bold">
                                    {item?.CodigoActivo} - {item.NombreActivo}
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                                <Badge
                                  value={item.StatusName}
                                  style={
                                    colorsStatus["status" + item?.IdEstado]
                                  }
                                />
                              </div>

                              <div
                                style={{ borderBottom: "1px solid #ccc" }}
                              ></div>

                              <div
                                className="mt-2"
                                style={{ maxHeight: "20vh", overflowY: "auto" }}
                              >
                                <h6>
                                  <strong>
                                    {getLabel(
                                      baseLang,
                                      "descripcion",
                                      config.language
                                    )}
                                    :{" "}
                                  </strong>
                                  {item.DescripcionSubTareas}
                                </h6>

                                {/* <h6><strong>Area: </strong>{item.Area}</h6> */}
                                <h6>
                                  <strong>
                                    {getLabel(
                                      baseLang,
                                      "tipoMantenimiento",
                                      config.language
                                    )}
                                    :{" "}
                                  </strong>
                                  {item.TipoMantenimiento}
                                </h6>
                                <h6>
                                  <strong>
                                    {getLabel(
                                      baseLang,
                                      "tipoTrabajo",
                                      config.language
                                    )}
                                    :{" "}
                                  </strong>
                                  {item.TipoTrabajo}
                                </h6>
                                <h6>
                                  <strong>
                                    {getLabel(
                                      baseLang,
                                      "asignado",
                                      config.language
                                    )}
                                    :{" "}
                                  </strong>
                                </h6>
                                <div style={{ marginBottom: "5px" }}>
                                  {item.NombreConcatenado?.length > 0 ? (
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, 1fr)",
                                        gap: "8px",
                                        backgroundColor: "#e5f8fd",
                                        borderRadius: "10px",
                                        padding: "8px",
                                      }}
                                    >
                                      {item.NombreConcatenado.map(
                                        (nombre, idIndex) => (
                                          <span
                                            key={idIndex}
                                            style={{
                                              fontSize: "12px",
                                              color: "#333",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {nombre}
                                          </span>
                                        )
                                      )}
                                    </div>
                                  ) : (
                                    "No se ha seleccionado personal"
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="d-flex mb-2 justify-content-between">

                              <div className='d-flex gap-2'>
                                <Button
                                  icon="pi pi-play"
                                  severity="success"
                                  tooltip="Iniciar"
                                  tooltipOptions={{ position: "top" }}
                                  onClick={() => openModal(item.IdAsignacion, 1)}
                                  disabled={ item.IdEstado === 49 || item.IdEstado === 52 }
                                />
                                <Button
                                  icon="pi pi-stop"
                                  severity="danger"
                                  tooltip="Detener"
                                  tooltipOptions={{ position: "top" }}
                                  onClick={() => openModal(item.IdAsignacion, 2) }
                                  disabled={item.IdEstado !== 49}
                                />
                                <Button
                                  icon="pi pi-check"
                                  tooltip="Completar"
                                  tooltipOptions={{ position: "top" }}
                                  onClick={() => openModal(item.IdAsignacion, 3) }
                                  disabled={item.IdEstado !== 49}
                                />

                              </div>

                              <div className='d-flex gap-2'>
                                <Button
                                  icon="pi pi-shopping-cart"
                                  tooltip="Requisa de Compra"
                                  tooltipOptions={{ position: "top" }}
                                  onClick={() => { 
                                    setItem(item)
                                    setAbrirRequisaCompras(true)
                                  }}
                                  disabled={item.IdEstado === 52}
                                />
                                <Button
                                  icon="ri-building-4-line"
                                  tooltip="Requisa de Material"
                                  tooltipOptions={{ position: "top" }}
                                  onClick={() => { 
                                    setItem(item)
                                    setAbrirRequisaMaterial(true)
                                  }}
                                  disabled={item.IdEstado === 52}
                                />
                                <Button
                                  icon="pi pi-eye"
                                  tooltip="Ver Requisas"
                                  tooltipOptions={{ position: "top" }}
                                  onClick={() => { 
                                    setItem(item)
                                    setShowRequisas(true)
                                  }}
                                />

                              </div>
                            </div>

                          </div>
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            }
          />
        ))}
      </div>
    );
  };

  const getInfoFiltrada = async () => {
    setLoading(true);
    let asignacionesTempo

    if(values?.Estado?.IdStatus || values?.Personal?.IdPersonal){ 
      if(values?.Estado?.IdStatus && values?.Personal?.IdPersonal){
        asignacionesTempo = await getAsignacionesPorPersonalFilt(values?.Estado?.IdStatus, values?.Personal?.IdPersonal)
      }else{
        if(!values?.Personal?.IdPersonal && (userAuth?.IdRol === 1 || hiddenMantenimiento)){
          asignacionesTempo = await getAsignacionesPorPersonalFilt(values?.Estado?.IdStatus)
        }else if(!values?.Estado?.IdStatus){
          asignacionesTempo = await getAsignacionesPorPersonalFilt(values?.Estado?.IdStatus, values?.Personal?.IdPersonal)
        }else{
          asignacionesTempo = await getAsignacionesPorPersonalFilt(values?.Estado?.IdStatus, userAuth?.IdPersonal)
        }
      }
      setAsignaciones(asignacionesTempo)
    }else {
      getInfo()
    }

    const ordenesDetTempo = await getOrdenesTrabajoDet()
    setOrdenesDet(ordenesDetTempo)
    
    setLoading(false);
  };

  const cambiarEstado = async () => {
    if(iniciar){
      const result = await iniciarTarea(idAsig, comment, userAuth?.IdUser);
      toast.current.show({ severity: 'success', summary: 'Iniciada', detail: "Tarea Iniciada exitosamente" });
      setTimeout(() => {
        getInfo();
        reject();
      }, 800);
    }else if(detener){
      if(!comment){
        toastShow(toast, "error", "Error", "Debe agregar un comentario.");
        return
      }
      const result = await detenerTarea(idAsig, comment, userAuth?.IdUser);
      toastShow(toast, "success", "Detenida", "Tarea Detenida exitosamente");
      setTimeout(() => {
        getInfo();
        reject();
      }, 800);
    }else if(finalizar){
      const result = await terminarTarea(idAsig, comment, userAuth?.IdUser);
      toast.current.show({ severity: 'success', summary: 'Finalizada', detail: "Tarea enviada a revisión" });
      setTimeout(() => {
        getInfo();
        reject();
      }, 800);
    }
  }

  const openModal = (IdAsignacion, tipo) => {
    switch (tipo) {
      case 1:
        setIniciar(true);
        break;
      case 2:
        setDetener(true);
        break;
      case 3:
        setFinalizar(true);
        break;
      default:
        break; 
    }
    
    setIdAsig(IdAsignacion)
    setShowDialog(true);
  };
  
  const reject = () => {
    setShowDialog(false);
    setComment(null);
    setIdAsig(null)
    setIniciar(false)
    setDetener(false)
    setFinalizar(false)
  };

  const cerrarConfirmacionCompras = () => {
    if (habilitarReqCompras) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setAbrirRequisaCompras(false);
          setItem([])
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
      setItem([])
    } 
  };

  const cerrarConfirmacionMaterial = () => {
    if (habilitarReqCompras) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setAbrirRequisaMaterial(false);
          setItem([])
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
      setItem([])
    } 
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ordenToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog2(null);
          setOrdenToShow(null);
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog2(null);
      setOrdenToShow(null);
      setHabilitar(true);
    }
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "asignaciones", config.language));
    getInfo();
  }, []);

  useEffect(() => {
    getInfoFiltrada();
  }, [values?.Estado?.IdStatus, values?.Personal?.IdPersonal]);
  

  return (
    <div className="p-fluid px-4 mt-4" style={{ width: "100%", height: "98%", margin: "auto" }}>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "asignaciones", config.language)}</h3>
            <Button
              icon="pi pi-eye"
              type="button"
              tooltip="Ver todas las asignaciones"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "right",
              }}
              onClick={(e) => {
                getInfo()
              }}
              tabIndex={7}
            />
          </div>
        }
        contenido={
          <div className="p-1 overflow-auto" style={{ height: "85vh" }}>
            {/* Estado */}
            <div style={{ width: "40%" }} className="mt-4 gap-2 d-flex">
              <AutoCompleteDropdown
                name={"Estado"}
                items={estados}
                value={values?.Estado}
                handleInputChange={handleInputChange}
                field={"StatusName"}
                label={"Estado"}
              />

              {/* Personal */}
              {hiddenMantenimiento || userAuth?.IdRol === 1 && (
                <AutoCompleteDropdown
                  name={"Personal"}
                  items={personalAsignado}
                  value={values?.Personal}
                  handleInputChange={handleInputChange}
                  field={"NombreConcatenado"}
                  label={"Personal"}
                />
              )}
            </div>

            <div className="d-flex flex-wrap gap-4 mt-2">
              {renderizarOrdenes(asignacionesAgrupadas)}
            </div>
          </div>
        }
      />

      {/* Dialogo */}
      <Dialog
          header="Confirmación"
          visible={showDialog}
          style={{ width: '450px' }}
          footer={
            <div>
              <Button label="No" icon="pi pi-times" onClick={reject} className="p-button-text" />
              <Button label="Sí" icon="pi pi-check" onClick={cambiarEstado} autoFocus />
            </div>
          }
          onHide={() => {
            setShowDialog(false)
            setIniciar(false)
            setDetener(false)
            setFinalizar(false)
            setComment(null)
          }}
        >
          <Toast ref={toast} />
          {iniciar && (<p>¿Estás seguro de que deseas iniciar esta tarea?</p>)}
          {detener && (<p>¿Estás seguro de que deseas detener esta tarea?</p>)}
          {finalizar && (<p>¿Estás seguro de que deseas finalizar esta tarea?</p>)}

        <InputText
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Ingrese un comentario"
          style={{ width: '100%' }}
        />
      </Dialog>


      {/* Requisa Compra */}
      <Dialog
        visible={abrirRequisaCompras}
        onHide={() => {cerrarConfirmacionCompras()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <CrudRequisa
          showDialog={abrirRequisaCompras}
          habilitar={habilitarReqCompras}
          setHabilitar={setHabilitarReqCompras}
          item={item}
        />
      </Dialog>

      {/* Requisa Material */}
      <Dialog
        visible={abrirRequisaMaterial}
        onHide={() => {cerrarConfirmacionMaterial()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RequisaMaterialCrud
          setIngresoToShow={setIngresoToShow}
          showDialog={abrirRequisaMaterial}
          actualizarIngresosScreen={getInfo}
          habilitar={habilitarReqMaterial}
          setHabilitar={setHabilitarReqMaterial}
          item={item}
        />
      </Dialog>

      {/* Listado de Requisas */}
      <Dialog
        visible={showRequisas}
        onHide={() => {
          setShowRequisas(false)
          setItem([])
        }}
        // maximizable={true}
        closeOnEscape={false}
        style={{width: '61%', height: '70%'}}
      >
        <RequisasDeAsignaciones item={item} />
      </Dialog>


      <Dialog
        visible={showDialog2}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <OrdenesTrabajoCRUD
          idOrden={ordenToShow}
          setOrdenToShow={setOrdenToShow}
          showDialog={showDialog2}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>
    </div>
  );
};

export default AsignacionesScreen;
